















































































import { Vue, Component, Model, Emit } from "vue-property-decorator";
import { Product } from "@/controller/my-routine-products";
import CategoriesPicker from "./CategoriesPicker.vue";
import StepPicker from "./StepPicker.vue";
import { formRules } from "@/const/form-rules";

@Component({
  components: {
    CategoriesPicker,
    StepPicker
  }
})
export default class AddProductPopup extends Vue {
  @Model("input", { type: Boolean, required: true })
  show!: boolean;

  step = "";
  productUrl: string | null = null;
  haravanProductId: string | null = null;
  categories: string[] = [];
  name: string | null = null;
  description: string | null = null;
  imageUrl: string | null = null;

  formIsValid = true;
  rules = formRules;

  @Emit("input")
  emitClose() {
    return false;
  }

  @Emit("click")
  emitClick(): Product {
    return {
      step: this.step,
      product_url: this.productUrl as string,
      haravan_product_id: this.haravanProductId as string,
      categories: this.categories,
      name: this.name as string,
      description: this.description as string,
      image_url: this.imageUrl as string
    };
  }

  get buttonIsDisabled(): boolean {
    return !this.hasCategories;
  }

  get hasCategories(): boolean {
    return this.categories.length > 0;
  }

  async addProduct() {
    this.validateForm();

    if (!this.formIsValid) {
      return;
    }

    this.emitClick();
  }

  private validateForm() {
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }
}
